<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px">
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="6" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0" class="form-step0-excel">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <v-label>
                      Descargar la plantilla de importación de puntos de entrega.
                      <v-label @click="downloadExcel" class="text-download font-weight-bold ms-1 me-1"> Descargar </v-label>
                    </v-label>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excelFile"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>
                  </v-form>
                </v-col>
              </v-row>

              <!--step 1-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step1">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[1].title }}</b>
                      </p>
                    </div>
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important" class="mb-3 mt-3">
                      <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                    </v-progress-linear>

                    <v-data-table :headers="headers" :items="list_bulk" :search="search" :loading="loading_table" :items-per-page="10" hide-default-footer dense>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.object.name }}</td>
                          <td>{{ item.object.mail }}</td>
                          <td>{{ item.object.phone }}</td>
                          <td>{{ item.object.address }}</td>
                          <td>{{ item.object.location }}</td>
                          <td>{{ item.object.postal_code }}</td>
                          <td>{{ item.object.provincia_name }}</td>
                          <td v-if="!isClient">{{ item.object.client_name }}</td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg == '' && !item.status_create">
                            <i class="fa fa-check text-green"></i>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg != '' && !item.status_create">
                            <span class="text-red">{{ item.msg }}</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.status_create">
                            <span class="text-green">Importado</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 0">
                            {{ "Pendiente de procesado" }}
                          </td>
                          <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white">
                <v-btn @click="prev" color="blue-grey" variant="outlined" v-if="step > 0">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1">
                  <v-chip color="success" class="mr-2">Importados: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error" class="">Fallidos: {{ importaciones_no_creadas }}</v-chip>
                  <v-btn v-if="importaciones_no_creadas > 0" @click="downloadErrorsExcel" color="error" variant="outlined" size="small" class="ml-3"> Descargar Errores </v-btn>
                </div>

                <v-btn class="float-right" variant="outlined" color="primary" @click="readExcel" v-if="step == 0" :disabled="excelFile == null && step == 0"> Siguiente</v-btn>
              </v-col>
              <v-col cols="12" style="background-color: #fafafa; border-top: 1px solid #c1c1c1" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled" :loading="loading" v-if="!disabled && step == 1">{{ formBtn }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import ValidMixin from "@/mixins/ValidMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import readXlsxFile from "read-excel-file";
import { SUBCLIENT_COLUMNS } from "@/constants/ExcelColumnMappings";

export default {
  components: {},
  mixins: [ValidMixin, ExportMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    isClient: Boolean,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      step: 0,
      headers: [],
      steps: [
        {
          title: "Importar Excel",
          description: "Importe el Excel",
          content: "First-content",
        },
        {
          title: "Detalle del Excel",
          description: "Detalle del Excel",
          content: "Second-content",
        },
      ],
      excelFile: null,
      list_bulk: [],
      loading_create: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      total_importaciones: 0,
      submit_disabled: false,
      progress: 0,
      loading_table: false,
      search: "",
    };
  },
  watch: {},
  mounted() {
    // Configurar headers según el tipo de usuario
    this.headers = [
      {
        title: "Nombre",
        align: "left",
        sortable: true,
        key: "name",
      },
      {
        title: "Email",
        align: "left",
        sortable: true,
        key: "mail",
      },
      {
        title: "Teléfono",
        align: "left",
        sortable: true,
        key: "phone",
      },
      {
        title: "Dirección",
        align: "left",
        sortable: true,
        key: "address",
      },
      {
        title: "Localidad",
        align: "left",
        sortable: true,
        key: "location",
      },
      {
        title: "Código Postal",
        align: "left",
        sortable: true,
        key: "postal_code",
      },
      {
        title: "Provincia",
        align: "left",
        sortable: true,
        key: "provincia_name",
      },
    ];

    // Si es admin, agregar columna Cliente
    if (!this.isClient) {
      this.headers.push({
        title: "Cliente",
        align: "left",
        sortable: true,
        key: "client_name",
      });
    }

    // Agregar columna de resultado al final
    this.headers.push({
      title: "Resultado",
      align: "left",
      sortable: false,
      key: "msg",
    });
  },

  computed: {
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },

  methods: {
    downloadExcel() {
      const params = {}; // Agregar parámetros si son necesarios
      const fileName = "plantilla_puntos_entrega.xlsx";

      this.exportExcel(this.service.section + "/get-sample-excel", params, fileName);
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },

    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      try {
        const rows = await readXlsxFile(this.excelFile, {
          sheet: 1,
          dateFormat: "YYYY-MM-DD",
        });
        console.log("Rows:", rows);

        for (const element of rows.slice(1)) {
          const obj = {
            object: this.parseObject(element),
            msg: "",
            status: 0,
            status_create: false,
            loading: false,
          };
          this.list_bulk.push(obj);
        }
      } catch (error) {
        console.error(error);
        this.toast.error("Error al leer el archivo Excel");
      } finally {
        this.loading_table = false;
      }
    },
    parseObject(element) {
      const object = {};

      object.name = element[SUBCLIENT_COLUMNS.NOMBRE] || "";
      object.mail = element[SUBCLIENT_COLUMNS.EMAIL] || null;
      object.phone = element[SUBCLIENT_COLUMNS.TELEFONO] ? element[SUBCLIENT_COLUMNS.TELEFONO].toString() : null;
      object.address = element[SUBCLIENT_COLUMNS.DIRECCION] || "";
      object.reference = element[SUBCLIENT_COLUMNS.REFERENCIA] || null;
      object.location = element[SUBCLIENT_COLUMNS.LOCALIDAD] || "";
      object.postal_code = element[SUBCLIENT_COLUMNS.CODIGO_POSTAL] ? element[SUBCLIENT_COLUMNS.CODIGO_POSTAL].toString() : "";
      object.provincia_name = element[SUBCLIENT_COLUMNS.PROVINCIA] || "";
      object.lat = element[SUBCLIENT_COLUMNS.LATITUD] || null;
      object.lng = element[SUBCLIENT_COLUMNS.LONGITUD] || null;
      object.external_reference = element[SUBCLIENT_COLUMNS.REFERENCIA_EXTERNA] || null;

      // Si es admin, incluir cliente (columna L)
      if (!this.isClient) {
        object.client_name = element[SUBCLIENT_COLUMNS.CLIENTE] || "";
      }

      return object;
    },

    closeDialog() {
      this.$emit("updateDialog", false);
      this.resetForm();
    },

    resetForm() {
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.total_importaciones = 0;
      this.submit_disabled = false;
      this.loading = false;
      this.loading_create = false;
      this.loading_table = false;

      // Reset forms si existen
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      if (this.$refs.form_step0) {
        this.$refs.form_step0.reset();
      }
      if (this.$refs.form_step1) {
        this.$refs.form_step1.reset();
      }
    },
    prev() {
      this.step--;
    },

    async importar() {
      var index = 0;
      this.loading_create = true;
      this.submit_disabled = true;

      for (const element of this.list_bulk) {
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = result.msg;

          if (result.status) {
            this.importaciones_creadas++;
          } else {
            this.importaciones_no_creadas++;
          }
        }

        index++;
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.$emit("updateDialog", false);
        this.resetForm();
        this.$emit("loadList");
      }
    },
    async createItem(item) {
      try {
        const response = await this.service.import_line_excel(item);
        return {
          status: response.status,
          msg: response.msg || (response.status ? "Importación exitosa" : "Error en la importación"),
        };
      } catch (error) {
        return {
          status: false,
          msg: error.response?.data?.msg || error.message || "Error en la importación",
        };
      }
    },

    downloadErrorsExcel() {
      const errorsData = this.list_bulk.filter((item) => item.status === 1 && !item.status_create && item.msg !== "");

      if (errorsData.length === 0) {
        this.$toast.warning("No hay errores para exportar");
        return;
      }

      // Transformar los datos para el backend
      const formattedErrors = errorsData.map((item) => ({
        object: item.object,
        msg: item.msg,
      }));

      const params = {
        errors_data: formattedErrors,
      };
      const fileName = `errores_importacion_puntos_entrega.xlsx`;

      this.exportExcel(this.service.section + "/get-excel-with-errors", params, fileName);
    },
  },
};
</script>

<style scoped>
.text-download {
  cursor: pointer;
  color: #1976d2;
  text-decoration: underline;
}

.text-download:hover {
  color: #1565c0;
}

.text-green {
  color: #4caf50;
}

.text-red {
  color: #f44336;
}

.bg-subtitle-section {
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
}
</style>
